import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkTreeModule } from '@angular/cdk/tree';
import { RouterModule } from '@angular/router';
// Primeng modules
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { SupportComponent } from './support-user/support-user.component';
import { SharedModule } from '../../shared/shared.module';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TicketsListComponent } from './tickets-list/tickets-list.component';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TicketDetailsDialogComponent } from './ticket-details-dialog/ticket-details.dialog.component';
import { TechniciansListComponent } from './technicians-list/technicians-list.component';
import { TicketDialogComponent } from './tickets-dialog/ticket.dialog.component';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { CardModule } from 'primeng/card';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TechnicianAddDialogComponent } from './technician-add-dialog/technician-add.dialog.component';
import { TechnicianEditDialogComponent } from './edit-technician-dialog/technician-edit.dialog.component';


@NgModule({
    declarations: [
      SupportComponent,
      TicketsListComponent,
      TicketDetailsDialogComponent,
      TechniciansListComponent,
      TicketDialogComponent,
      TechnicianAddDialogComponent,
      TechnicianEditDialogComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule,
        ReactiveFormsModule,
        CdkTreeModule,
        // primeng modules
        BlockUIModule,
        ButtonModule,
        InputTextModule,
        RippleModule,
        TabViewModule,
        TableModule,
        TagModule,
        TooltipModule,
        ConfirmDialogModule,
        DropdownModule,
        CalendarModule,
        FormsModule,
        ReactiveFormsModule,
        CheckboxModule,
        CardModule,
        RadioButtonModule,
    ],
    exports: [
      SupportComponent,
    ]
})
export class SupportModule { }
